import React, { useState, useEffect } from "react";
import { Field, FieldArray, useFormikContext } from "formik";
import {
  FieldDragandDropComponent,
  FieldDropSide,
  FieldInput,
  FieldInputTrash,
  SearchableList,
  SourceCollectionsFilter,
  TransformationFunctionCard,
  VariableCard,
} from "../../../components";
import {
  DataTypeForTransformationFunction,
  getFilteredFunctionList,
  required,
  transformationFunctions,
} from "../../../utils";
import { get, isNull } from "lodash";
import { useRouterParams } from "../../../abstracts";

const MapperFunction = (props) => {
  const {
    fields,
    forFileNameConfigure,
    parameterTypes,
    setClickToSelect,
    clickToSelect,
    setKey,
    setFieldArrayName,
    fieldName = "",
    index = null,
    isAdded = false,
    isHeader = false,
    isValue = false,
    hasHeader = null,
    headerError,
    valueError,
    functionList,
    isSplitConfigured,
    deserializeHeaderMapJson,
  } = props;
  const { values, setFieldValue } = useFormikContext();
  const { flow, profileId, mapType } = useRouterParams();
  const [showSlider, setShowSlider] = useState(false);
  const objName = !isValue ? "headerData" : "valueData";
  const collectionData = isNull(index)
    ? get(values, `${objName}.value`, false)
    : get(values, `${fieldName}.value`, false);

  const parameterType = isNull(index)
    ? get(values, `${objName}.parameterType`)
    : get(values, `${fieldName}.parameterType`);

  const headerName = isNull(index)
    ? get(values, `${objName}.headerName`)
    : get(values, `${fieldName}.headerName`);
  const data = isNull(index)
    ? get(values, `${objName}.value.parameters`, [])
    : get(values, `${fieldName}.value.parameters`, []);

  useEffect(() => {
    if (collectionData?.isCollectionParent) {
      setShowSlider(true);
    }
  }, [collectionData]);

  const handlePress = (event) => {
    if (event.key == "Enter") {
      event.preventDefault();
      document.getElementById("saveonEnter").click();
    }
  };

  const onDeleteClick = () => {
    let fName = fieldName.slice(0, -3);
    let data = fieldName.slice(0, -14);
    let val = get(values, fName, []);
    let dataVal = get(values, data, []);
    setFieldValue(data, {
      ...dataVal,
      numberOfParameters: dataVal.numberOfParameters - 1,
    });
    setFieldValue(
      fName,
      val?.filter((_, i) => i !== index)
    );
  };
  const editFlowHeaderName = transformationFunctions.find(
    (_) => _.id == get(values, `${objName}.value.id`)
  );
  return (
    <div>
      {isValue || (isHeader && hasHeader) ? (
        <FieldArray
          name={fieldName}
          render={(arrayHelpers) => (
            <>
              {headerName ?? editFlowHeaderName?.parameters[index]?.headerName}
              <div className="d-flex mapper-func-container">
                <Field
                  name={
                    isNull(index)
                      ? `${objName}.${fields.parameterType}`
                      : `${fieldName}.parameterType`
                  }
                  value={parameterType}
                  options={
                    isNull(index) && forFileNameConfigure
                      ? parameterTypes.filter((x) => x.value == 2)
                      : parameterTypes
                  }
                  isRequired
                  direction={"bottom"}
                  size="sm"
                  popupContent={
                    <SearchableList
                      label="Click here to add"
                      isNotTypeAhead
                      options={
                        isNull(index) && forFileNameConfigure
                          ? parameterTypes.filter((x) => x.value == 2)
                          : parameterTypes
                      }
                      onSelect={(value) => {
                        if (isNull(index)) {
                          setFieldValue(
                            `${objName}.${fields.parameterType}`,
                            value
                          );
                          setFieldValue(
                            `${objName}.${fields.value}`,
                            value === 3 ? "" : null
                          );
                        } else {
                          setFieldValue(`${fieldName}.parameterType`, value);
                          setFieldValue(`${fieldName}.value`, null);
                        }
                      }}
                      selectedValue={
                        isNull(index) && forFileNameConfigure
                          ? parameterTypes.filter((x) => x.value == 2)
                          : parameterTypes
                      }
                    />
                  }
                  forMapper={true}
                  component={FieldDropSide}
                  dropdownClassName={`dropdownBox ${
                    collectionData?.isCollection ? "mapper-collection" : ""
                  }`}
                />

                {parameterType == 1 && (
                  <FieldDragandDropComponent
                    index={index}
                    values={values}
                    objName={objName}
                    fieldName={fieldName}
                    setFieldValue={setFieldValue}
                    forFunction={true}
                    isAdded={isAdded}
                    onDeleteClick={onDeleteClick}
                    isCollection={collectionData?.isCollection}
                    setFieldArrayName={setFieldArrayName}
                    setClickToSelect={setClickToSelect}
                    clickToSelect={clickToSelect}
                    headerError={headerError}
                    valueError={valueError}
                  />
                )}

                {parameterType == 2 && (
                  <TransformationFunctionCard
                    functionList={
                      mapType == 3 || 2 ? transformationFunctions : functionList
                    }
                    index={index}
                    values={values}
                    isAdded={isAdded}
                    objName={objName}
                    fieldName={fieldName}
                    onDeleteClick={onDeleteClick}
                    setFieldValue={setFieldValue}
                    headerError={headerError}
                    valueError={valueError}
                  />
                )}

                {parameterType == 3 && (
                  <Field
                    type="text"
                    name={
                      isNull(index)
                        ? `${objName}.${fields.value}`
                        : `${fieldName}.value`
                    }
                    placeHolder="Enter any value"
                    size="smdd"
                    validate={required}
                    isRequired
                    isAdded={isAdded}
                    onDeleteClick={onDeleteClick}
                    forMapper={true}
                    component={FieldInputTrash}
                  />
                )}

                {parameterType == 4 && (
                  <VariableCard
                    deserializeHeaderMapJson={deserializeHeaderMapJson}
                    isSplitConfigured={isSplitConfigured}
                    index={index}
                    values={values}
                    isAdded={isAdded}
                    objName={objName}
                    fieldName={fieldName}
                    onDeleteClick={onDeleteClick}
                    setFieldValue={setFieldValue}
                    headerError={headerError}
                    valueError={valueError}
                  />
                )}

                {isValue && collectionData?.isCollectionParent && (
                  <SourceCollectionsFilter
                    setShowSlider={setShowSlider}
                    showSlider={showSlider}
                    fieldName={
                      isNull(index)
                        ? `${objName}.value`
                        : fieldName == ""
                        ? `${objName}.${fieldName}value`
                        : `${fieldName}value`
                    }
                    propertyName={collectionData?.propertyName}
                    collectionName={collectionData?.propertyNameParent}
                  />
                )}
              </div>
              {parameterType == 2 && (
                <div className="mapper-dashed-border">
                  {data.map((data, index) => {
                    return (
                      <div
                        className="mapper-line"
                        style={{ position: "relative" }}
                      >
                        <div className="d-flex align-items-center">
                          <div className="ptb-1">
                            <MapperFunction
                              deserializeHeaderMapJson={
                                deserializeHeaderMapJson
                              }
                              isSplitConfigured={isSplitConfigured}
                              functionList={getFilteredFunctionList(
                                data?.dataType,
                                false
                              )}
                              fieldName={
                                isNull(index)
                                  ? `${objName}.value.parameters`
                                  : fieldName == ""
                                  ? `${objName}.${fieldName}value.parameters[${index}]`
                                  : `${fieldName}value.parameters[${index}]`
                              }
                              fields={fields}
                              index={index}
                              isHeader={isHeader}
                              isValue={isValue}
                              hasHeader={hasHeader}
                              isAdded={data?.isAdded}
                              parameterTypes={parameterTypes}
                              setClickToSelect={setClickToSelect}
                              setFieldArrayName={setFieldArrayName}
                              headerError={headerError}
                              valueError={valueError}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
        />
      ) : (
        <Field
          label="Enter Header"
          name={"headerData.value"}
          type="text"
          size="smd"
          autoComplete="nope"
          value={values.headerData.value}
          disabled={mapType == 3 ? true : false}
          isRequired={mapType == 3 ? true : false}
          onChange={(evt) => {
            setFieldValue("headerData.value", evt.target.value);
            if (!hasHeader) {
              setFieldValue("headerData.parameterType", 0);
            }
          }}
          onKeyPress={handlePress}
          component={FieldInput}
        />
      )}
    </div>
  );
};

export default MapperFunction;
